import {
  CovideoGTMVideoMessageProperties,
  GTMVideoMessageProperties,
} from './types';

export function mapToGtmVideoMessageProperties(
  item?: CovideoGTMVideoMessageProperties
): GTMVideoMessageProperties {
  if (!item) return {} as GTMVideoMessageProperties;

  return {
    customer_id: item?.customerId || undefined,
    sms: item?.sms || undefined,
    email: item?.email || undefined,
    notification_viewed: item?.notificationViewed || false,
    landing_page: item?.landingPage || undefined,
    call_to_action: item?.callToAction || undefined,
    thumbnails: item?.thumbnails || undefined,
  };
}

export function getVideoDurationMs(
  file: File,
  timeoutMs = 8000
): Promise<number> {
  return new Promise(resolve => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');

    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;

    let settled = false;

    const finish = (ms: number) => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve(Math.round(ms));
    };

    const cleanup = () => {
      clearTimeout(timer);
      video.removeEventListener('loadedmetadata', onLoadedMetadata);
      video.removeEventListener('durationchange', onDurationChange);
      video.removeEventListener('error', onError);
      URL.revokeObjectURL(url);
      video.src = '';
    };

    const timer = setTimeout(() => {
      // fallback on timeout
      finish(0);
    }, timeoutMs);

    const tryResolve = () => {
      if (isFinite(video.duration) && video.duration > 0) {
        finish(video.duration * 1000);
      }
    };

    const onLoadedMetadata = async () => {
      tryResolve();
      try {
        await video.play(); // Safari fallback
      } catch {}
      tryResolve();
    };

    const onDurationChange = () => {
      tryResolve();
    };

    const onError = () => {
      // fallback on error
      finish(0);
    };

    video.addEventListener('loadedmetadata', onLoadedMetadata);
    video.addEventListener('durationchange', onDurationChange);
    video.addEventListener('error', onError);

    video.src = url;
    try {
      video.load();
    } catch {
      finish(0);
    }
  });
}
